import * as React from 'react';
import { useCallback, useState } from 'react';
import { useTranslationWithPrefix } from '@hotjar/translations';
import { Trans } from 'react-i18next';
import { Button } from '@hotjar/hotsauce';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';
import { EmailVerificationComponent } from '../components';
import { VerifyEmailPageStyles } from './style';
import type { StepProps } from './types';

const { GetNewCodeLink, Title, ActionBar } = VerifyEmailPageStyles;

export const Step2 = ({ email, onBack, onNext }: StepProps): React.ReactElement<StepProps> => {
  const { t } = useTranslationWithPrefix('auth:enforce-mfa-verify-email:step2');
  const [isLoading, setLoading] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const { click } = useTrack();

  const onEmailLinkClick = (provider: string): void => {
    click(provider, 'Enforce MFA email verification', {});
  };

  const onEmailVerified = useCallback(() => {
    setIsSuccess(true);
    onNext();
  }, [onNext]);

  return (
    <>
      <Title>{t('title')}</Title>
      <EmailVerificationComponent
        userEmail={email}
        onEmailVerified={onEmailVerified}
        onLoadingChange={setLoading}
        onEmailLinkClick={onEmailLinkClick}
        footer={(sendVerificationEmail) => (
          <Trans i18nKey="auth:enforce-mfa-verify-email.step2.get-new-code">
            <GetNewCodeLink data-testid="get-new-link" onClick={sendVerificationEmail}>
              get a new code
            </GetNewCodeLink>
          </Trans>
        )}
      />

      <ActionBar>
        <Button kind="secondary" onClick={onBack}>
          {t('back')}
        </Button>
        <Button
          kind="primary"
          isLoading={isLoading}
          isDisabled={!isSuccess}
          onClick={() => {
            onNext();
          }}
          type="submit"
        >
          {t('action')}
        </Button>
      </ActionBar>
    </>
  );
};
